import { useNavigate, useParams } from "react-router-dom";
import { EnumEnquiryTypes, IEnquiry, onlyRemarkForms } from "../types/flights";
import React, { useEffect, useState } from "react";
import { appAxios } from "../../axios/axios";
import {
  IMessage,
  RemarkType,
  TChatMessage,
} from "../../interfaces/enquiry.interface";
import { EDFlightSegment } from "./EnquiryDetailSubComponents/EDFlightSegment";
import { EDPassengersDetails } from "./EnquiryDetailSubComponents/EDPassengersDetails";
import { toast } from "react-toastify";
import { useAppSelector } from "../../store";
import { EDHotelSub } from "./EnquiryDetailSubComponents/EDHotelSub";
import { EDPaxCount } from "./EnquiryDetailSubComponents/EDPaxCount";
import moment from "moment";
import { EDVisaSub } from "./EnquiryDetailSubComponents/EDVisaSub";
import { MainLoader } from "../Common/Ui/MainLoader";
import { getUsersByUuid } from "../../utils/User";
import enquiryscss from "../../sass/enquiry-list/Enquiry.module.scss";
import { Modal } from "react-bootstrap";
import { SearchCustomerSelect } from "../Common/SearchCustomerSelect";
import { EnquiryChangeLogsModal } from "./EnquiryDetailSubComponents/EnquiryChangeLogsModal";
import { CommonChatComponent } from "./EnquiryDetailSubComponents/CommonChatComponent";

type TChatTabKeys = "Customer" | "Staff" | "Chat";

type TTabDetail = {
  tabName: TChatTabKeys;
  tabKey: RemarkType;
};

type TTabWiseChat = TTabDetail & {
  messages: TChatMessage[];
};

const ViewEnquiryDetails: React.FC<{}> = () => {
  const params = useParams();
  const enquiryId: number = parseInt(params.id || "");
  const navigate = useNavigate();
  const websiteMenu = useAppSelector((state) => state.siteData.websiteMenu);
  const userData = useAppSelector((state) => state.users.userData);
  const [enquiryData, setEnquiryData] = useState<IEnquiry>();

  const defaultTabName = userData?.userType === "staff" ? "Customer" : "Chat";
  const [activeTabDetail, setActiveTabDetail] = useState<TTabDetail>({
    tabName: defaultTabName,
    tabKey: "public",
  });
  const defaultTabWiseChat: TTabWiseChat[] = [
    {
      tabName: defaultTabName,
      tabKey: "public",
      messages: [],
    },
  ];

  if (userData?.userType === "staff") {
    defaultTabWiseChat.push({
      tabName: "Staff",
      tabKey: "internal",
      messages: [],
    });
  }
  const [tabWiseChatsState, setTabWiseChatsState] =
    useState<TTabWiseChat[]>(defaultTabWiseChat);

  const [fetchingData, setFetchingData] = useState({
    enquiryData: false,
    publicRemark: false,
    internalRemark: false,
  });

  const [showChangeCustomerModal, setShowChangeCustomerModal] = useState(false);
  const [showChangeLogsModal, setShowChangeLogsModal] = useState(false);

  async function addUsersInRemark(remarkData: any[]) {
    const uuidArr = remarkData?.map((data) => {
      return data.uuid;
    });

    const saveResponse = await getUsersByUuid(uuidArr);

    const remarkWUserData: IMessage[] = remarkData?.map((remarkData) => {
      const userData = saveResponse.result.find(
        (user) => user.uuid === remarkData.uuid
      );
      return { ...remarkData, userData: userData, send: true };
    });
    return remarkWUserData;
  }

  async function getRemarks() {
    try {
      if (activeTabDetail.tabKey === "public") {
        setFetchingData({
          enquiryData: false,
          publicRemark: true,
          internalRemark: false,
        });
        const remarks = await appAxios(
          "/query-management/getAllEnquiryRemarks",
          {
            method: "POST",
            data: {
              enquiryId,
              remarkType: "public",
            },
          }
        );
        const remarkRes = await addUsersInRemark(remarks?.data?.result);
        setTabWiseChatsState((old) => {
          old[0].messages = remarkRes.reverse().map((mes) => {
            return {
              senderDetails: {
                name: `${mes.userData.firstName} ${mes.userData.lastName}`,
              },
              send: mes.send,
              ownMessage: userData?.uuid === mes.userData.uuid,
              message: mes.remark,
              documentUrl: mes.documentUrl,
              createdAt: mes.createdAt,
              documentType: mes.documentType,
            };
          });
          return [...old];
        });
        setFetchingData({
          enquiryData: false,
          publicRemark: false,
          internalRemark: userData?.userType === "staff",
        });
      }
      if (
        userData?.userType === "staff" &&
        activeTabDetail.tabKey === "internal"
      ) {
        const internalRemarks = await appAxios(
          "/query-management/getAllEnquiryRemarks",
          {
            method: "POST",
            data: {
              enquiryId,
              remarkType: "internal",
            },
          }
        );
        const internalRemarkRes = await addUsersInRemark(
          internalRemarks?.data?.result
        );
        setTabWiseChatsState((old) => {
          old[1].messages = internalRemarkRes.reverse().map((mes) => {
            return {
              senderDetails: {
                name: `${mes.userData.firstName} ${mes.userData.lastName}`,
              },
              send: mes.send,
              ownMessage: userData?.uuid === mes.userData.uuid,
              message: mes.remark,
              createdAt: mes.createdAt,
              documentType: mes.documentType,
              documentUrl: mes.documentUrl,
            };
          });
          return [...old];
        });
        setFetchingData({
          enquiryData: false,
          publicRemark: false,
          internalRemark: false,
        });
      }
    } catch (error: any) {
      setFetchingData({
        enquiryData: false,
        publicRemark: false,
        internalRemark: false,
      });
      toast.error(
        error?.response?.errorMessage ||
          error.errorMesage ||
          "Failed to load messages"
      );
    }
  }

  async function sendMsg(chatMsg: string, remarkType: RemarkType) {
    try {
      let indexToUpdate = tabWiseChatsState[0].messages.length;
      if (remarkType === "public") {
        setTabWiseChatsState((old) => {
          old[0].messages.push({
            createdAt: new Date(),
            message: chatMsg,
            send: false,
            ownMessage: true,
            senderDetails: {
              name: `${userData?.firstName} ${userData?.lastName}`,
            },
          });
          return [...old];
        });
      } else {
        indexToUpdate = tabWiseChatsState[1].messages.length;
        setTabWiseChatsState((old) => {
          old[1].messages.push({
            createdAt: new Date(),
            message: chatMsg,
            send: false,
            ownMessage: true,
            senderDetails: {
              name: `${userData?.firstName} ${userData?.lastName}`,
            },
          });
          return [...old];
        });
      }
      const saveResponse = await appAxios(
        "/query-management/saveEnquiryRemark",
        {
          method: "POST",
          data: {
            remark: chatMsg,
            enquiryId: enquiryId,
            remarkType,
          },
        }
      );

      if (saveResponse.data.success) {
        if (remarkType === "public") {
          setTabWiseChatsState((old) => {
            if (old[0]?.messages?.[indexToUpdate]) {
              old[0].messages[indexToUpdate].send = true;
            }

            return [...old];
          });
        } else {
          setTabWiseChatsState((old) => {
            if (old[1]?.messages?.[indexToUpdate]) {
              old[1].messages[indexToUpdate].send = true;
            }

            return [...old];
          });
        }
        return true;
      }
    } catch (error) {}
    return false;
  }

  function getHeading(type: EnumEnquiryTypes) {
    switch (type) {
      case "Flight Enquiry":
        const segmentStr = enquiryData?.flightSegments
          ?.map((seg) => `${seg.origin}-${seg.destination}`)
          ?.join(" , ");

        return segmentStr;
      case "Hotel Enquiry":
        return enquiryData?.hotel.city;
      case "Visa Enquiry":
        return enquiryData?.visaEnquires
          ?.map((visa) => visa.country)
          .join(" , ");
      default:
        return "Enquiry Details:";
    }
  }

  function convertedEnquiryData(type: EnumEnquiryTypes) {
    let convertedData: any = {};
    switch (type) {
      case "Flight Enquiry":
        convertedData = {
          remark: enquiryData?.remark,
          type: enquiryData?.type,
          noOfAdult: enquiryData?.noOfAdult,
          noOfChild: enquiryData?.noOfChild,
          noOfInfant: enquiryData?.noOfInfant,
          segments: enquiryData?.flightSegments,
          passengers: enquiryData?.passengers,
        };
        break;

      case "Hotel Enquiry":
        const hotelDetails = enquiryData?.hotel;
        convertedData = {
          hotelName: hotelDetails?.hotelName,
          category: hotelDetails?.category,
          checkin: moment(hotelDetails?.checkin).toDate(),
          checkout: moment(hotelDetails?.checkout).toDate(),
          isFlexible: hotelDetails?.isFlexible,
          city: hotelDetails?.city,
          noOfAdult: enquiryData?.noOfAdult,
          noOfChild: enquiryData?.noOfChild,
          noOfInfant: enquiryData?.noOfInfant,
          type: enquiryData?.type,
          rooms: hotelDetails?.rooms,
          remark: enquiryData?.remark,
        };
        break;

      case "Other Enquiry":
        convertedData = {
          remark: enquiryData?.remark,
          type: enquiryData?.type,
          passengers: enquiryData?.passengers,
        };
        break;

      case "Visa Enquiry":
        convertedData = {
          remark: enquiryData?.remark,
          type: enquiryData?.type,
          visaEnquires: enquiryData?.visaEnquires,
          noOfAdult: enquiryData?.noOfAdult,
          noOfChild: enquiryData?.noOfChild,
          noOfInfant: enquiryData?.noOfInfant,
        };
        break;

      default:
        convertedData = null;
        break;
    }
    return convertedData;
  }

  async function getEnquiryData(enquiryId: number) {
    try {
      setFetchingData((old) => {
        old.enquiryData = true;
        return { ...old };
      });
      const enquiryResponse = await appAxios(
        "/query-management/getEnquiryById",
        {
          method: "POST",
          data: {
            id: enquiryId,
          },
        }
      );
      const enquiryRes: IEnquiry = enquiryResponse.data.result;
      if (enquiryRes) {
        const userDataRes = await getUsersByUuid([
          enquiryRes?.uuid,
          enquiryRes.assignedToStaffUUID,
        ]);
        userDataRes.result.forEach((user) => {
          if (user.uuid === enquiryRes.uuid) {
            enquiryRes.userData = user;
          }
          if (user.uuid === enquiryRes.assignedToStaffUUID) {
            enquiryRes.assignedToStaffData = user;
          }
        });
        setEnquiryData(enquiryRes);
      } else {
        throw new Error("Enquiry not found");
      }
      setFetchingData((old) => {
        old.enquiryData = false;
        return { ...old };
      });
    } catch (error) {
      navigate("/notFound", {
        replace: true,
      });
    }
  }

  const updateEnquiryCustomer = async (
    enquiryId: number,
    customerId: number,
    customerUUID: string
  ) => {
    try {
      const updateCustomerRes = await appAxios(
        "/query-management-staff/updateQuery",
        {
          method: "POST",
          data: {
            id: enquiryId,
            queryData: {
              userId: customerId,
              uuid: customerUUID,
            },
          },
        }
      );

      if (updateCustomerRes.data.success) {
        getEnquiryData(enquiryId);
        setShowChangeCustomerModal(false);
        toast.success("customer update successfully!");
      }
    } catch (error: any) {
      toast.error(error.data.errorMessage || "Customer Not Updated");
    }
  };

  const enquiryDocumentUpload = async (formData: FormData) => {
    formData.append("enquiryId", enquiryId.toString());
    formData.append("remarkType", activeTabDetail.tabKey);

    const savedResponse = await appAxios.post(
      "query-management/uploadDocument",
      formData,

      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (savedResponse.data.success) {
      getRemarks();
    }

    return savedResponse.data.result;
    // }
    //  catch (error: any) {
    //   console.log(error);
    //   return toast.error("File Upload Failed");
    // }
  };

  useEffect(() => {
    if (enquiryId) {
      getEnquiryData(enquiryId);
      getRemarks();
    } else {
      navigate("/notFound", {
        replace: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getRemarks();
  }, [activeTabDetail]);

  return (
    <React.Fragment>
      <MainLoader
        loading={fetchingData.enquiryData || !enquiryData}
        height="calc(100vh - 200px)"
      />
      <div className="container ">
        {/* <Link className=" btn btn-sm back-btn " to={"/"}>
          <i className="fa-solid fa-chevron-left"></i>
          Go to list
        </Link> */}
      </div>
      {enquiryData && (
        <div className={`container ${enquiryscss.enquiryDetails} mt-5`}>
          <div className={`status-${enquiryData.queryStatus} mb-1`}></div>
          <div className={enquiryscss.enquiryCreatedDetails}>
            <div className="row justify-content-between align-items-center">
              <div className="d-flex">
                <h5>
                  {getHeading(
                    enquiryData?.subject || enquiryData?.type || "Other Enquiry"
                  )}
                </h5>
                <div
                  className={`${enquiryscss.enquiryType} d-flex align-items-center`}
                >
                  {enquiryData?.subject || enquiryData?.type}
                </div>
              </div>
              <span className={enquiryscss.createHeading}>
                created at:
                <span className={enquiryscss.createContent}>
                  {moment(enquiryData?.createdAt).format(
                    "MMMM Do YYYY, h:mm a"
                  )}
                </span>
              </span>
              <div className="col-lg-8 col-md-9 col-8">
                <div className={`${enquiryscss.enquiryPersonDetails} mt-2`}>
                  <div className={enquiryscss.enquiryPersonName}>
                    <b> Name: </b>
                    {`${
                      enquiryData?.userData
                        ? enquiryData?.userData.firstName +
                          " " +
                          enquiryData?.userData.lastName
                        : ""
                    }`}
                  </div>
                  {enquiryData.userData?.phone &&
                    (userData?.userType === "staff" ? (
                      <div className={enquiryscss.enquiryPersonPhone}>
                        <b> Phone: </b>
                        <span
                          className={enquiryscss.enquiryPersonPhoneWithWhatsapp}
                          onClick={(e) => {
                            let phoneCode = enquiryData.userData.phoneCode;
                            if (!phoneCode || phoneCode === "INVALID") {
                              phoneCode = "";
                            }
                            window.open(
                              `https://wa.me/${phoneCode}${enquiryData.userData.phone}`,

                              "_blank"
                            );
                          }}
                        >
                          {`${`${
                            !enquiryData.userData.phoneCode ||
                            enquiryData.userData.phoneCode === "INVALID"
                              ? ""
                              : enquiryData.userData.phoneCode
                          } ${enquiryData.userData.phone}`}`}
                          <i className="fa-brands fa-whatsapp text-success ms-1"></i>
                        </span>
                      </div>
                    ) : (
                      <div className={enquiryscss.enquiryPersonPhone}>
                        <b> Phone: </b>

                        {`${`${
                          !enquiryData.userData.phoneCode ||
                          enquiryData.userData.phoneCode === "INVALID"
                            ? ""
                            : enquiryData.userData.phoneCode
                        } ${enquiryData.userData.phone}`}`}
                      </div>
                    ))}
                </div>
                {enquiryData.assignedToStaffData ? (
                  <div className={enquiryscss.enquiryPersonDetails}>
                    <div className={enquiryscss.enquiryPersonName}>
                      <b> Assigned Staff: </b>
                      {`${
                        enquiryData?.assignedToStaffData.firstName +
                        " " +
                        enquiryData?.assignedToStaffData.lastName
                      }`}
                    </div>
                  </div>
                ) : (
                  userData?.userType === "staff" && (
                    <span className="text-danger small badge border rounded-pill">
                      Unassigned
                    </span>
                  )
                )}
              </div>

              {!onlyRemarkForms.includes(enquiryData.type) && (
                <div className="col-lg-4 col-md-3 col-4 text-end">
                  {/* callback enquiry button to be implemented in future */}
                  {/* <button className="btn border rounded-pill btn-sm me-2">
                  <i className="fas fa-phone text-success"></i>
                </button> */}
                  <button
                    className={`btn btn-primary btn-sm ${enquiryscss.enquiryEditButton}`}
                    onClick={() => {
                      const navigateUrl = websiteMenu.find(
                        (menu) => menu.type === enquiryData?.type
                      )?.moduleLink;
                      navigate(`/${navigateUrl}`, {
                        state: {
                          enquiryId: enquiryData?.id,
                          enquiryData: convertedEnquiryData(
                            enquiryData?.subject ||
                              enquiryData?.type ||
                              "Other Enquiry"
                          ),
                        },
                      });
                    }}
                  >
                    <i className="far fa-edit"></i> Edit
                  </button>
                </div>
              )}

              {userData?.userType === "staff" && (
                <>
                  <div className="text-end">
                    <button
                      className="btn btn-primary rounded"
                      onClick={() => {
                        setShowChangeCustomerModal(true);
                      }}
                    >
                      change customer
                    </button>
                  </div>
                  <div className="logs-btn text-primary">
                    <span
                      className="text-primary border-bottom  border-dark"
                      role="button"
                      onClick={() => {
                        setShowChangeLogsModal(true);
                      }}
                    >
                      Logs
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
          {enquiryData.type === "Tour Enquiry" && (
            <>
              <div className="text-primary mt-3">{enquiryData.title}</div>

              <div className="container mt-4">
                <h5>Customer Details</h5>
                <div className="d-flex flex-column small">
                  <div>
                    <strong>Name:</strong> {enquiryData.fullName}
                    <span className="mx-2">|</span>
                    <strong>Email:</strong> {enquiryData.email}
                    <span className="mx-2">|</span>
                    <strong>Phone Number:</strong> {enquiryData.phoneCode}{" "}
                    {enquiryData.phoneNumber}
                  </div>
                </div>
              </div>
            </>
          )}
          {enquiryData?.noOfAdult && (
            <EDPaxCount
              paxCount={{
                ADULT: enquiryData?.noOfAdult || 1,
                CHILD: enquiryData?.noOfChild || 0,
                INFANT: enquiryData?.noOfInfant || 0,
              }}
            />
          )}
          <EDFlightSegment segments={enquiryData?.flightSegments} />
          <EDHotelSub hotelEnquiryData={enquiryData?.hotel} />
          <EDVisaSub visaEnquiryData={enquiryData?.visaEnquires} />
          <EDPassengersDetails passengers={enquiryData?.passengers} />
          <div className="remark-container d-flex mt-2">
            <span className="me-2">
              <b> Remark: </b>{" "}
            </span>
            <span
              className=""
              dangerouslySetInnerHTML={{ __html: enquiryData?.remark || "" }}
            ></span>
          </div>
          <div
            style={{
              height: "75px",
            }}
          ></div>
        </div>
      )}
      <CommonChatComponent
        selectedTab={activeTabDetail.tabName}
        chatTabDetails={tabWiseChatsState}
        getMessages={getRemarks}
        onTabChange={(tabDetails: any) => {
          setActiveTabDetail(
            tabDetails || {
              tabName: defaultTabName,
              tabKey: "public",
            }
          );
        }}
        sendMsg={(msg) => {
          sendMsg(msg, activeTabDetail.tabKey);
        }}
        showUploadDocumentButton={true}
        onDocumentUpload={enquiryDocumentUpload}
      />
      {/* <ChatComponent
        remarkMessages={remarkMessages}
        internalRemarkMessages={internalRemarkMessages}
        sendMsg={sendMsg}
        getRemarkMessages={getRemarks}
      /> */}
      <Modal
        show={showChangeCustomerModal}
        onHide={() => setShowChangeCustomerModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Config</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <div className="small">
            <label htmlFor="">Change Customer</label>
            <SearchCustomerSelect
              onChange={(e) => {
                if (!e) {
                  return;
                }
                updateEnquiryCustomer(enquiryId, e.user.id, e.value);
              }}
              value={enquiryData?.userData.uuid}
            />
          </div>
        </Modal.Body>
      </Modal>

      {showChangeLogsModal && (
        <EnquiryChangeLogsModal
          onClose={() => {
            setShowChangeLogsModal(false);
          }}
          showChangeLogsModal={showChangeLogsModal}
          enquiryId={enquiryId}
        />
      )}
    </React.Fragment>
  );
};
export default ViewEnquiryDetails;
